<template>
  <div class="broadcast">
    <v-head></v-head>
    <div class="broadcast_content">
      <div class="broadcast_content_one"></div>
      <div class="broadcast_content_two"  v-for="b in broadcast_list" style="background: url({{b.image}}) no-repeat center/cover;position: relative" >
        <div class="broadcast_content_pulic">
          <div class="broadcast_content_two_two">
            <div>
              <!--<p class="broadcast_content_two_tre"><a v-link="{name:'slide',:{id:'adsdasd'}}">{{b.title}}</a></p>-->
              <p class="broadcast_content_two_tre"><a v-link="{name:'slide', params: { id: b.id}}">{{b.title}}</a></p>
              <p class="broadcast_content_two_four">{{b.abstract}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-footer></v-footer>
  </div>

</template>

<script>
  import head from 'components/head/head.vue';
  import footer from 'components/footer/footer.vue';
  export default {
    data () {
      return {
          broadcast_list:[],
          urla:"http://112.74.184.45:882/",
          urls:""
      }
    },
    components: {
      "v-head": head,
      "v-footer": footer
    },
    ready () {
      var _this = this;
      $.ajax({
        type: "get",
        url: __formalUrl__ + "api/getNewsByTypeId/96",
        data:{} ,
        dataType: "json",
        success: function (data) {
          if (data) {
            _this.broadcast_list = data.data;
            console.log(888,_this.broadcast_list);
          }
        }
      });
    }
  }
</script>

<style>
  .broadcast{width: 9rem;margin: 0 auto;}
  .broadcast_content>div + div{margin-bottom: 0.4rem}
  .broadcast_content>div img{width: 100%;height:100%}
  .broadcast_content>div:first-child{width: 9rem;height:2.4rem }
  .broadcast_content>div:not(:first-child){width: 9rem;height: 4rem}
  .broadcast_content_one{background: url("../../../static/images/broadcast_banner.jpg") no-repeat center/cover;background-size: 9rem 2.4rem;}
  /*.broadcast_content_two{background: url(../../../static/images/broadcast_2.jpg) no-repeat center/cover;position: relative}*/
  .broadcast_content_pulic{border: 0.02rem solid #ffffff;width: 8rem;height: 3.6rem;margin: 0 auto;position: absolute;top:calc(50% - 1.8rem);left: calc(50% - 4rem)}
  .broadcast_content_pulic p{color: #000000;font-size: 0.16rem;margin-top: 0.2rem}
  .broadcast_content_two_two{width: 7.5rem;height: 3.2rem;background-color: #ffffff;opacity: 0.8;position: absolute;top:calc(50% - 1.6rem);left: calc(50% - 3.75rem)}
  .broadcast_content_two_two div{width: 6rem;height: 1.8rem;margin: 0 auto;position: absolute;top: calc(50% - 0.9rem);left: calc(50% - 3rem)}
  .broadcast_content_two_tre{border-bottom: 0.01rem solid #000000;width: 6rem;text-align: center;margin: 0 auto;padding-bottom: 0.2rem}
  .broadcast_content_two_four{font-size: 0.12rem;}
  .broadcast_content_two_two>div p a{font-size: 0.25rem;color: #000000}
  .broadcast_content_tre{background: url(../../../static/images/broadcast_2.jpg) no-repeat center/cover;position: relative}
  .broadcast_content_four{background: url(../../../static/images/broadcast_1.jpg) no-repeat center/cover;position: relative}

  @media screen and (max-width: 50em) and (min-width:20em ){
    .broadcast{overflow: hidden;width: 100%}
    .broadcast_content{margin-top: 0.5rem}
    .broadcast_content>div + div{margin-bottom: 0.4rem}
    .broadcast_content>div img{width: 100%;height:100%}
    .broadcast_content>div:first-child{width: 100%;height:1.6rem;}
    .broadcast_content>div:not(:first-child){width: 100%;height: 2rem}
    .broadcast_content_one{background: url("../../../static/images/broadcast_banner.jpg") no-repeat center/cover;background-size: 100% 100%;}
    .broadcast_content_two{background:url(../../../static/images/broadcast_3.jpg) no-repeat center/cover;position: relative;background-size: 100% 100%;}
    .broadcast_content_pulic{border: 0.02rem solid #ffffff;width: 80%;height: 1.8rem;margin: 0 auto;position: absolute;top:calc(50% - 0.9rem);left: calc(50% - 40%)}
    .broadcast_content_pulic p{color: #000000;font-size: 0.12rem;margin-top: 0.05rem;}
    .broadcast_content_two_two{width: 90%;height: 1.6rem;background-color: #ffffff;opacity: 0.8;position: absolute;top:calc(50% - 0.8rem);left: calc(50% - 45%);overflow: hidden}
    .broadcast_content_two_two div{width: 95%;height: 0.9rem;margin: 0 auto;position: absolute;top: calc(50% - 0.45rem);left: calc(50% - 47.5%)}
    .broadcast_content_two_tre{border-bottom: 0.01rem solid #000000;width: 100%;text-align: center;margin: 0 auto;padding-bottom: 0.2rem}
    .broadcast_content_two_four{font-size: 0.12rem;}
    .broadcast_content_two_two>div p a{font-size: 0.15rem;color: #000000}
    .broadcast_content_tre{background: url(../../../static/images/broadcast_2.jpg) no-repeat center/cover;position: relative}
    .broadcast_content_four{background: url(../../../static/images/broadcast_1.jpg) no-repeat center/cover;position: relative}
  }

</style>



// WEBPACK FOOTER //
// broadcast.vue?6174a144